<template>
    <div class="column" style="padding-bottom: 35px" v-if="!this.$q.platform.is.desktop">
        <div :class="{ 'col-auto sot-header sot-font row items-center no-wrap': true, 'sot-borders': !$q.platform.is.mobile }" :style="{ 'width': $q.platform.is.mobile ? '100%' : '400px' }">
            <img class="absolute-top full-width" src="~assets/ui/header.svg" style="object-fit: cover; width: 100%; border-radius: 22px 22px 0 0">
            <div v-show="(params && params.uuid === 'root') || bigHeader" class="col-auto row items-center text-white z-max q-gutter-x-md" style="margin-top: -10px">
                <q-img class="col-auto" src="~assets/ui/1t-kurs-logo.svg" fit="contain" width="44px" />
                <div class="col text-h6">{{ $store.state.platform.settings.defaultPageTitle }}</div>
            </div>
            <!--
            <q-img v-show="(params && params.uuid === 'root') || bigHeader" class="col-auto" src="~assets/ui/sot-text.svg" fit="contain" width="130px" style="margin-top: 10px;" />
            -->
            <q-btn v-show="(!params || (params && params.uuid !== 'root' && params.back_button_visible !== '0')) && !bigHeader && !hideBackButton" flat round @click="back">
                <q-img src="~assets/ui/button-header-back.svg" width="32px" />
            </q-btn>

            <div class="col text-white text-center full-width" v-if="!bigHeader" :style="{ 'z-index': '999' }">
                <div v-if="!params || (params && params.uuid !== 'root')" class="ellipsis-2-lines">
                    <span v-if="params">{{ params.title }}</span>
                    <span v-if="label">{{ label }}</span>
                </div>
            </div>
            <q-btn v-show="(!params || (params && params.uuid !== 'root' && params.back_button_visible !== '0')) && !bigHeader && !hideBackButton" flat round class="no-pointer-events">
                <!--<q-img src="~assets/ui/button-header-back.svg" width="32px" />-->
            </q-btn>

            <!--
            <div class="col text-white text-center" v-if="!bigHeader" :style="{ 'z-index': '999', 'margin-left': '4px', 'margin-right': !params || (params && params.back_button_visible !== '0') ? '32px' : '0' }">
                <div v-if="!params || (params && params.uuid !== 'root')" class="ellipsis-2-lines">
                    <span v-if="params">{{ params.title }}</span>
                    <span v-if="label">{{ label }}</span>
                </div>
            </div>
            -->

            <div v-if="false" v-show="params && params.uuid === 'root'" class="col-auto" style="margin-right: -5px;">
                <q-btn flat round>
                    <q-img src="~assets/ui/main-menu-button.svg" width="23px" />
                </q-btn>
            </div>
        </div>
        <div v-if="bigHeader" class="col-auto">
            <q-img src="~assets/ui/header.svg" fit="contain" style="width: 100%" />
            <q-img src="~assets/ui/big-header.jpg" fit="contain" style="width: 100%; margin-top: -20px;" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'SotHeader',
    props: {
        params: {
            type: Object,
            default: undefined,
        },
        label: {
            type: String,
            default: undefined,
        },
        bigHeader: {
            type: Boolean,
            default: false,
        },
        hideBackButton: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        back (e) {
            this.$emit('back', e);
            if (e.cancelBubble) {
                return;
            }
            this.$pages.back();
        },
    },
};
</script>

<style scoped lang="scss">
    .sot-header {
        // background-image: url('~assets/ui/header.svg');
        // background-repeat: no-repeat;
        min-height: 72px;
        height: 100px;
        padding: 0 20px 15px 15px;
        position: absolute;
        z-index: 199;
        left: 50%;
        transform: translate(-50%, 0);
    }
    .sot-borders {
        border-radius: 20px 20px 0 0;
    }
</style>
